<div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title" *ngIf="validPreguntaEdit(); else elseBlock">Editar pregunta</h2>
      <ng-template #elseBlock>
        <h2 class="modal-title">Nueva pregunta</h2>
      </ng-template>
      <button
        type="button"
        class="close"
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="reset()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form
      id="formNewPregunta"
      [formGroup]="form"
      (submit)="formNewPregunta()"
      class="mt-3 mb-3"
    >
      <div class="modal-body">
        <div class="row">
          <div class="col col-md-12">
            <div class="form-group">
              <label for="pregunta">Pregunta:</label>
              <input
                required
                type="text"
                class="form-control"
                id="pregunta"
                name="pregunta"
                formControlName="pregunta"
                maxlength="128"
                value=""
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col col-md-3" *ngIf="validPreguntaEdit()">
            <div class="form-group">
              <label>Orden:</label>
              <input
                required
                type="number"
                class="form-control"
                id="ordenEditPregunta"
                name="ordenEditPregunta"
                formControlName="orden"
                min="1"
                readonly
              />
            </div>
          </div>
          <div
            class="col"
            [class]="validPreguntaEdit() ? 'col-md-3' : 'col-md-4'"
          >
            <label>Requiere evidencia</label>
            <ul class="tg-list" class="text-left">
              <li class="tg-list-item">
                <input
                  class="tgl tgl-ios"
                  id="checkEvidencia"
                  name="checkEvidencia"
                  formControlName="checkEvidencia"
                  type="checkbox"
                  checked="true"
                />
                <label class="tgl-btn" for="checkEvidencia"></label>
              </li>
            </ul>
          </div>
          <div
            class="col"
            [class]="validPreguntaEdit() ? 'col-md-3' : 'col-md-4'"
          >
            <label>Requiere comentario</label>
            <ul class="tg-list" class="text-left">
              <li class="tg-list-item">
                <input
                  class="tgl tgl-ios"
                  id="checkComentario"
                  name="checkComentario"
                  formControlName="checkComentario"
                  type="checkbox"
                />
                <label class="tgl-btn" for="checkComentario"></label>
              </li>
            </ul>
          </div>
          <div
            class="col"
            [class]="validPreguntaEdit() ? 'col-md-3' : 'col-md-4'"
          >
            <div class="form-group">
              <label for="ponderacion">Ponderación:</label>
              <input
                placeholder="0-100"
                type="number"
                class="form-control"
  
                id="ponderacion"
                name="ponderacion"
                formControlName="ponderacion"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-sm btn-primary" [disabled]="btnDisable">
          <i class="fa fa-save"></i> Guardar
        </button>
      </div>
    </form>
  </div>
  